export const getUrl =  (url = '') => {
    return `${window.location.origin}${url}`;
};
